import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Card } from "antd";
import { addNewSupervisor, editSupervisor } from "../../redux/actions/supervisor";
import { getAllZonesApi, getAllDistrictsApi } from "../../apis/districts";
import { getAllTenantsApi } from "../../apis/tenants";
import CustomInput from "../../common/CustomInput";
import CustomButton from "../../common/CustomButton";
import CustomSelect from "../../common/CustomSelect";

const AddOpsManager = ({ role, currentUserDetails = {}, isEdit }) => {
  const [userDetails, setUserDetails] = useState(currentUserDetails);
  const [zones, setZones] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [tenants, setTenants] = useState([]);
  const dispatch = useDispatch()

  const isZoneSelected = !!userDetails?.zoneId;
  const isTenantSelected = !!userDetails?.tenantId;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [zonesRes, districtsRes, tenantsRes] = await Promise.all([
          getAllZonesApi(),
          getAllDistrictsApi(),
          getAllTenantsApi()
        ]);

        setZones(zonesRes);
        setDistricts(districtsRes.data.content);
        if (tenantsRes) setTenants(tenantsRes);
      } catch (error) {
        console.error("Failed to fetch data:", error);
      }
    };

    fetchData();
  }, []);

  const handleAddLeader = () => {
    if (userDetails.username) {
      if (!isEdit) {
        const payload = {
          "username": userDetails.username,
          "role": role,
          "name": userDetails.name,
          "phonenumber": userDetails.phonenumber,
          ...(userDetails.zoneId && { "zoneId": userDetails.zoneId, "zoneName": userDetails.zoneName }),
          ...(userDetails.tenantId && { "tenantId": userDetails.tenantId }),
        }
        dispatch(addNewSupervisor(payload))
      } else {
        const { supervisorId, key, ...editableDetails } = userDetails;
        dispatch(editSupervisor(editableDetails, userDetails.supervisorId));
      }
    } else {
      return;
    }
  };

  return (
    <Card
      title={
        isEdit
          ? `Edit ${role === "OPERATION_MANAGER" ? "Ops Manager" : "Cluster Leader"}`
          : `Add ${role === "OPERATION_MANAGER" ? "Ops Manager" : "Cluster Leader"}`
      }
      bordered
      style={{ border: "2px solid rgb(0, 168, 204)" }}
      styles={{
        header: { borderBottom: "2px solid rgb(0, 168, 204)", fontSize: "2rem", textAlign: "center", color: "rgb(0, 168, 204)" },
      }}
    >
      <div style={{ display: "flex", flexWrap: "wrap", alignItems: "flex-end", gap: "0.5rem" }}>
        <CustomInput
          label={"Email"}
          placeholder="Enter Email"
          value={userDetails?.username}
          onChange={(e) => setUserDetails({ ...userDetails, username: e.target.value })}
          required={true}
          requiredMessage="User Email is required"
        />
        <CustomInput
          label={"Name"}
          placeholder="Enter Name"
          value={userDetails?.name}
          onChange={(e) => setUserDetails({ ...userDetails, name: e.target.value })}
          required={true}
          requiredMessage="Name is required"
        />
        <CustomInput
          label={"Phone No"}
          placeholder="Enter Phone No"
          value={userDetails?.phonenumber}
          onChange={(e) => setUserDetails({ ...userDetails, phonenumber: e.target.value })}
          required={true}
          requiredMessage="Phone number is required"
        />
        {role === "CLUSTER_LEADER" && <CustomSelect
          label={"District"}
          placeholder="Select District"
          value={userDetails?.district}
          options={districts.map((district) => ({
            label: district.name,
            value: district.id
          }))}
          style={{ width: "7rem" }}
          mode={"multiple"}
          onChange={(val) => setUserDetails({ ...userDetails, owningEntityIds: val })}
        />}
        {role === "OPERATION_MANAGER" && <>
          <CustomSelect
            label="Zone"
            placeholder="Select Zone"
            value={userDetails?.zoneId}
            options={zones.map((zone) => ({ label: zone.name, value: zone.id }))}
            style={{ width: "9rem" }}
            disabled={isTenantSelected}
            allowClear
            onClear={() => setUserDetails({ ...userDetails, zoneId: undefined, zoneName: undefined })}
            onChange={(val) => {
              const selected = zones.find((z) => z.id === val);
              setUserDetails({ ...userDetails, zoneId: selected?.id, zoneName: selected?.name, tenantId: undefined });
            }}
          />
          <CustomSelect
            label="Tenant"
            placeholder="Select Tenant"
            value={userDetails?.tenantId}
            options={tenants.map((t) => ({ label: t.name, value: t.id }))}
            style={{ width: "9rem" }}
            disabled={isZoneSelected}
            allowClear
            onClear={() => setUserDetails({ ...userDetails, tenantId: undefined })}
            onChange={(val) => {
              setUserDetails({ ...userDetails, tenantId: val, zoneId: undefined, zoneName: undefined });
            }}
          />
        </>}
      </div>
      <div>
        <CustomButton
          type="primary"
          onClick={handleAddLeader}
          title={
            isEdit
              ? `Update ${role === "OPERATION_MANAGER" ? "Ops Manager" : "Cluster Leader"}`
              : `Add ${role === "OPERATION_MANAGER" ? "Ops Manager" : "Cluster Leader"}`
          }
          disabled={!userDetails.username}
        />
      </div>
    </Card>
  );
};

export default AddOpsManager;
